import request from '@/utils/request'

const api = {
  tagPageQuery: "/tag/pageQuery",
  del: "/tag/delete",
  edi: "/tag/save"
}

export default api

export function getTagList(data){
  return request({
    url: api.tagPageQuery,
    method: 'post',
    data
  })
}
export function delTag(data){
  return request({
    url: api.del,
    method: 'post',
    data
  })
}
export function addTagOrUpdateTag(data){
  return request({
    url: api.edi,
    method: 'post',
    data
  })
}